module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAYAAABV7bNHAAAAf0lEQVR42u3Xyw2AIBRFQUuhBEtQG6XEVwKy0MSFC4xukJnkFuCJH5wmAAAAAAAAAAA6tC5bqst1UVd+ujiuMT2NM/88zF2o+cmdM1Kca6TUEigPGOdcbgkUAweKlkBl5An0QSCPmJf0u5e0z7yD4ouDol8NAAAAAAAAAAD6sQOwfyMAEM0vYQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/devfest/2796.png
// module id = 1410
// module chunks = 0